import { render } from "./Notification.vue?vue&type=template&id=db0688c6&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=db0688c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db0688c6"

export default script